import { AnyAction, Dispatch, Middleware } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import { APP_ENV } from '@/global/enums/common.enums';

import { claimGalaApi } from '../services/claimGala.service';
import { otcApi } from '../services/otc.service';
import { priceApi } from '../services/price.service';
import { projectApi } from '../services/project.service';
import { redeemApi } from '../services/redeem.service';
import { referralApi } from '../services/referral.service';
import { rewardApi } from '../services/reward.service';

const middleware: Middleware[] = [
  claimGalaApi.middleware,
  priceApi.middleware,
  projectApi.middleware,
  redeemApi.middleware,
  referralApi.middleware,
  rewardApi.middleware,
  otcApi.middleware,
];

if (process.env.NEXT_PUBLIC_ENV === APP_ENV.DEV) {
  middleware.push(
    createLogger({
      duration: true,
      timestamp: false,
      collapsed: true,
      colors: {
        title: () => '#139BFE',
        prevState: () => '#1C5FAF',
        action: () => '#149945',
        nextState: () => '#A47104',
        error: () => '#ff0005',
      },
      predicate: () => typeof window !== 'undefined',
    }) as Middleware<{}, any, Dispatch<AnyAction>>, // Update the type of the middleware function
  );
}

export { middleware };
